import { entitiesReducer } from 'redux-query';
import { merge } from 'lodash';

import * as types from '../actions/constants';

const proxyReducer = (state, action) => {
  switch (action.type) {
    case types.BOOTSTRAP_LOADING:
      return { ...state, bootstrapping: true };
    case types.BOOTSTRAP_LOADED:
      return { ...state, bootstrapping: false };
    case types.QUERY_UPDATE_ENTITIES:
      return { ...state, ...action.payload };
    case types.TRANSFORM_ENTITIES:
      return merge(state, action.payload || {});
    default:
      return entitiesReducer(state, action);
  }
};

export default proxyReducer;
